import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import React from "react";
import TextAreaField from "./TextAreaField";

const defaultProps = {
    name: `field_${Math.ceil(Math.random() * 100)}`,
    label: `Select`,
    disabled: false,
    readOnly: false,
    isMinimal: false,
    // highlightEmpty: false,
    cellHighlightClasses: "",
    value: "",
    onChange: () => {},
    onClick: () => {},
    hasNA: false,
    reason: "",
    required: false,
    onReasonChange: () => {},
    onReasonClick: () => {},
    viewVertical: false,
};

const AffirmationField = (rawProps) => {

    const props = {...defaultProps, ...rawProps};

    return (
        <FormControl component='fieldset'>
            {/* <FormLabel component="legend">{props.label}</FormLabel> */}
            <RadioGroup
                row={!props.isMinimal || props.viewVertical === false}
                value={!["NA", "", null, undefined].includes(props.value) ? props.value : ""}
                onChange={(e) => (props.onChange(e, e.target.value), props.onClick(e, e.target.value))}
            >
                <FormControlLabel
                    control={<Radio />}
                    value="Yes"
                    label="Yes"
                    checked={props.value == "Yes"}
                    disabled={props.readOnly || props.disabled}
                    required={props.required}
                />
                <FormControlLabel
                    control={<Radio />}
                    value="No"
                    label="No"
                    checked={props.value == "No"}
                    disabled={props.readOnly || props.disabled}
                    required={props.required}
                />
                {[1, true].includes(props.hasNA) && (
                    <FormControlLabel
                        control={<Radio />}
                        value="NA"
                        label="NA"
                        checked={props.value == "NA"}
                        disabled={props.readOnly || props.disabled}
                        required={props.required}
                    />
                )}
                {[1, true].includes(props.hasNA) && props.value == "NA" && (
                    <div>
                        <TextAreaField
                            label={"NA Reason"}
                            type={"text"}
                            value={props.value == "NA" ? props.reason : ""}
                            onChange={(val, e) => props.onReasonChange(val, e)}
                            onBlur={props.onReasonClick}
                            disabled={props.readOnly || props.disabled}
                            error={false}
                        />
                    </div>
                )}
            </RadioGroup>
        </FormControl>
    );
};

export default AffirmationField;
